export default __webpack_public_path__ + "static/media/tik tac toe.b713726d.png";